const config: TourConfig = {
    title: 'Release 3.2',
    version: '3.2.x',
    contexts: {}
};

export default config;
